// Module
var code = "<template>\n  <require from=\"./pen-dimension-container\"></require>\n  <pen-dimension-container\n    pen-offer.bind=\"data.penOffer\"\n    pen-offer-id.bind=\"data.penOfferId\"\n    pen-id.bind=\"data.penId\"\n    pen-identifier.bind=\"data.penIdentifier\"\n  ></pen-dimension-container>\n</template>\n";
// Exports
export default code;